import { motion } from "framer-motion";
import { GraduationCap, BookOpen, CreditCard } from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import Accordion from "../../components/Accordion";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/e998be6f-fd28-4f6e-9ddb-b2bef70d1314" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

// Variantes para el contenedor principal (Efecto cascada/stagger)
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // Retardo entre la aparición del título y cada bloque
    },
  },
};

// Variantes para los elementos individuales (Aparición suave desde abajo)
const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

function DescuentosEscuelaNegocios() {
  const DataDisplay = ({ data }) => (
    <motion.div
      className="max-w-6xl m-auto  py-10 px-4"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }} // Animación se ejecuta cuando entra en pantalla
    >
      <div
        className="
      [&_h2]:text-2xl
        [&_h2]:text-[#004270]   
            [&_h2]:font-bold
         [&_h2_strong]:text-2xl
         [&_h2_strong]:text-[#febe10]
           [&_h3]:text-lg
                [&_h3]:font-bold
         [&_h3_strong]:text-lg
      relative overflow-hidden rounded-3xl p-6 md:p-10 border border-[#f1f5f9] bg-white shadow-xl"
      >
        {/* Título / Texto Portada */}
        <motion.div
          variants={itemVariants}
          className="text-center mb-4"
          dangerouslySetInnerHTML={{
            __html: data.texto_portada,
          }}
        />

        {data.bloque1 && (
          <div className="  link-with-arrow-1">
            <Accordion
              title="Descuentos automáticos"
              content={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque1,
                    }}
                  />
                </>
              }
            ></Accordion>
          </div>
        )}

        {data.bloque2 && (
          <div className=" link-with-arrow-1">
            <Accordion
              title="Pago y convenios"
              content={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque2,
                    }}
                  />
                </>
              }
            ></Accordion>
          </div>
        )}

        {data.bloque4 && (
          <div className=" link-with-arrow-1">
            <Accordion
              title="Plan de pagos"
              content={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque4,
                    }}
                  />
                </>
              }
            ></Accordion>
          </div>
        )}

        <div>
          <div
            variants={itemVariants}
            className=" link-with-arrow-1 mt-4"
            dangerouslySetInnerHTML={{
              __html: data.bloque3,
            }}
          />
        </div>
      </div>
    </motion.div>
  );

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default DescuentosEscuelaNegocios;
